(function () {
  var root = document.querySelector("[data-buy-now]");

  if (!root) {
    return;
  }

  var packEl = root.querySelector("[data-buy-pack]");
  var saveEl = root.querySelector("[data-buy-save]");
  var panelPackEl = root.querySelector("[data-buy-panel-pack]");
  var panelDescEl = root.querySelector("[data-buy-panel-desc]");
  var panelPriceEl = root.querySelector("[data-buy-panel-price]");
  var panelPricePerEl = root.querySelector("[data-buy-panel-price-per]");
  var panelSaveEl = root.querySelector("[data-buy-panel-save]");
  var panelPercentEl = root.querySelector("[data-buy-panel-percent]");
  var buyBtn = root.closest("section").querySelector("[data-buy-btn]");
  var options = root.querySelectorAll("[data-buy-option]");
  var mobileQuery = window.matchMedia("(max-width: 767px)");

  var visualContainer = root.closest("section").querySelector("[data-buy-visual]");
  var visualImages = visualContainer
    ? visualContainer.querySelectorAll("[data-buy-visual-img]")
    : [];

  var variantId = buyBtn ? buyBtn.dataset.variantId : null;
  var selectedPens = buyBtn ? Number(buyBtn.dataset.pens) || 1 : 1;
  var activeOption = null;
  var btnLabel = buyBtn ? buyBtn.dataset.btnText || buyBtn.textContent.trim() : "Buy now";

  function formatMoney(cents) {
    return (cents / 100).toLocaleString("en-GB", {
      style: "currency",
      currency: "GBP",
      minimumFractionDigits: 2,
    });
  }

  function isMobileLayout() {
    return mobileQuery.matches;
  }

  function updateBuyBtnLabel(priceDisplay) {
    if (!buyBtn) {
      return;
    }

    if (isMobileLayout() && priceDisplay) {
      buyBtn.textContent = priceDisplay + " | " + btnLabel;
    } else {
      buyBtn.textContent = btnLabel;
    }
  }

  function selectOption(btn) {
    var unitCount = Number(btn.dataset.unitCount);
    var saved = Number(btn.dataset.saved) || 0;
    var savedMoney = btn.dataset.savedMoney || "";
    var ml = btn.dataset.ml;
    var description = btn.dataset.description || "";
    var priceDisplay = btn.dataset.priceDisplay || "";
    var pricePerDisplay = btn.dataset.pricePerDisplay || "";
    var saveDisplay = btn.dataset.saveDisplay || "";
    var percentDisplay = btn.dataset.percentDisplay || "";
    var hasSave = btn.dataset.hasSave === "true";

    selectedPens = Number(btn.dataset.pens) || 1;
    activeOption = btn;

    options.forEach(function (option) {
      var isActive = option === btn;
      option.classList.toggle("buy-now__option--active", isActive);
      option.setAttribute("aria-pressed", isActive ? "true" : "false");
    });

    var optionIndex = btn.dataset.buyOption;
    if (visualImages.length > 0) {
      visualImages.forEach(function (img) {
        if (img.dataset.buyVisualImg === optionIndex) {
          img.classList.remove("buy-now__image--hidden");
        } else {
          img.classList.add("buy-now__image--hidden");
        }
      });
    }

    if (packEl) {
      var pensWord = unitCount === 1 ? "pen" : "pens";
      packEl.textContent = unitCount + " " + pensWord + " · " + ml + "ml total";
    }

    if (saveEl) {
      saveEl.textContent = savedMoney;
    }

    if (panelPackEl) {
      var panelPensWord = unitCount === 1 ? "pen" : "pens";
      panelPackEl.textContent = unitCount + " " + panelPensWord;
    }

    if (panelDescEl) {
      panelDescEl.textContent = description;
    }

    if (panelPriceEl) {
      panelPriceEl.textContent = priceDisplay;
    }

    if (panelPricePerEl) {
      panelPricePerEl.textContent = pricePerDisplay;
    }

    if (panelSaveEl) {
      panelSaveEl.textContent = savedMoney;
    }

    if (panelPercentEl) {
      if (hasSave && percentDisplay) {
        panelPercentEl.textContent = percentDisplay;
        panelPercentEl.hidden = false;
      } else {
        panelPercentEl.textContent = "";
        panelPercentEl.hidden = true;
      }
    }

    if (buyBtn) {
      buyBtn.dataset.pens = selectedPens;
    }

    updateBuyBtnLabel(priceDisplay);
  }

  if (buyBtn) {
    buyBtn.addEventListener("click", async function () {
      if (!variantId) return;

      var initialText = buyBtn.textContent;
      buyBtn.disabled = true;
      buyBtn.textContent = "Adding...";

      try {
        var sectionsPayload = {};
        var drawer = document.querySelector("[data-cart-drawer-root]");
        if (drawer && drawer.dataset.sectionId) {
          var cartPath = (window.__glowRoutes && window.__glowRoutes.cartUrl) || "/cart";
          sectionsPayload = {
            sections: drawer.dataset.sectionId,
            sections_url: cartPath.startsWith("/") ? cartPath : "/" + cartPath,
          };
        }

        var res = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(
            Object.assign({ id: Number(variantId), quantity: selectedPens }, sectionsPayload)
          ),
        });

        if (!res.ok) throw new Error("Add to cart failed");
        var data = await res.json();

        if (data.sections && window.cartUi && window.cartUi.applyBundledSections) {
          window.cartUi.applyBundledSections(data.sections);
        }

        if (window.cartUi) {
          await window.cartUi.syncCartCountFromApi();
          if (!window.cartUi.isDrawerOpen()) {
            window.cartUi.openDrawer();
          }
        }
      } catch (err) {
        console.error("Buy now add to cart error:", err);
      } finally {
        buyBtn.disabled = false;
        if (activeOption) {
          updateBuyBtnLabel(activeOption.dataset.priceDisplay || "");
        } else {
          buyBtn.textContent = initialText;
        }
      }
    });
  }

  options.forEach(function (option) {
    option.addEventListener("click", function () {
      selectOption(option);
    });
  });

  function handleLayoutChange() {
    if (activeOption) {
      updateBuyBtnLabel(activeOption.dataset.priceDisplay || "");
    }
  }

  if (mobileQuery.addEventListener) {
    mobileQuery.addEventListener("change", handleLayoutChange);
  } else if (mobileQuery.addListener) {
    mobileQuery.addListener(handleLayoutChange);
  }

  if (options.length) {
    selectOption(options[0]);
  }
})();
